import { QueryFunctionContext } from '@tanstack/react-query';

import { baseQuery } from '../baseQuery';
import type { BillingPlan } from 'types';

export const getBillingPlans = async ({ queryKey }: QueryFunctionContext<[string, number | undefined]>) => {
  const serviceTypeId = queryKey[1];

  const { data }: { data: BillingPlan[] } = await baseQuery(`billing-service-types/${serviceTypeId}/plans`);

  return data;
};
